import { render } from "./Success.vue?vue&type=template&id=1bf4d4dc&scoped=true&ts=true"
import script from "./Success.vue?vue&type=script&lang=ts"
export * from "./Success.vue?vue&type=script&lang=ts"

import "./Success.vue?vue&type=style&index=0&id=1bf4d4dc&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf4d4dc"]])

export default __exports__